export default __webpack_public_path__ + "static/media/plus.24975de0.png";